import { APPLE, EMAIL, FACEBOOK, GOOGLE } from './constants';

type ElementTypes =
  | typeof APPLE
  | typeof EMAIL
  | typeof FACEBOOK
  | typeof GOOGLE;

export const elemAttrForAnalytics = (option: ElementTypes) => {
  switch (option) {
    case FACEBOOK:
      return 'facebook_signup';
    case APPLE:
      return 'apple_signup';
    case EMAIL:
      return 'email_signup';
    case GOOGLE:
      return 'google_signup';
    default:
      return 'signup';
  }
};
